var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("content-container", { attrs: { showCastle: false } }, [
    _c("h1", [_vm._v("YOU FAILED")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }